<template>
	<div class="ml-auto">		
		<button type="button" class="btn btn-danger btn-sm" v-if="active" @click="deactivate()" :class="{'btn-loading': ajax}">Deactivate</button>
		<button type="button" class="btn btn-primary btn-sm" v-else @click="activate()" :class="{'btn-loading': ajax}">Activate</button>
	</div>
</template>

<script>
  	import {HTTP} from '@/components/HTTP.js'

  	export default {
  		props: ['isActive','observingId'],
  		data: function(){
  			return {
  				ajax: false,
  				active: true
  			}
  		},
  		created: function(){
  			if (this.isActive !== 1) this.active = false;
  		},
  		methods: {
	  		activate: function(){
	  			this.ajax = true;
	  			HTTP.put(`observing/${this.observingId}/activate`)
	  			.then((res) => {	  				
	  				this.ajax = false;
	  				if (res.data.status) this.active = true;
	  				else alert("Action Failed.");	  				
	  			})
	  			.catch((e) => {
	  				this.ajax = false;
	  				alert("Action Failed.");
	  			})	
	  		},
	  		deactivate: function(){
	  			this.ajax = true;
	  			HTTP.put(`observing/${this.observingId}/deactivate`)
	  			.then((res) => {
	  				this.ajax = false;
	  				if (res.data.status) this.active = false;
	  				else alert("Action Failed.");
	  			})
	  			.catch((e) => {
	  				this.ajax = false;
	  				alert("Action Failed.");
	  			})	
	  		},
  		}
  	}


</script>


// WEBPACK FOOTER //
// src/components/ToogleStatus.vue